import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  name: 'facility-name',
  addressLine1: 'facility-addressLine1',
  addressLine2: 'facility-addressLine2',
  cityInput: 'facility-city',
  stateSelect: 'facility-state',
  countrySelect: 'facility-country',
  postalInput: 'facility-postal',
  submitBtn: 'facility-submit',
  submitCancel: 'facility-cancel',
};

export default prefixObjectValues(modal, 'account-employment-facility-form');
